import React from 'react';

import { AiAvatar } from '~/components/AiChat/components/Message/AiAvatar';
import { AiMessageContent } from '~/components/AiChat/components/Message/AiMessageContent';
import { MessageLayout } from '~/components/AiChat/components/Message/MessageLayout';
import { MESSAGE_VARIANT } from '~/components/AiChat/components/Message/MessageTypes';

export interface AiGreetingProps {
  text: string;
}

export const AiGreeting: React.FC<AiGreetingProps> = ({ text }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(text);
  };

  return (
    <MessageLayout avatar={<AiAvatar />} variant={MESSAGE_VARIANT.AI}>
      <AiMessageContent className="p-0" text={text} sender={null} isLoading={false} onCopy={handleCopy} />
    </MessageLayout>
  );
};
